import { callToolsAPI } from '../../callApi';
import { StripePaymentInformation } from '../../types';

export const createPaymentIntent = (paymentInformation: StripePaymentInformation) => {
  return callToolsAPI('/payment/intent', '', {
    method: 'POST',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(paymentInformation),
  });
};
